/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Information ist nicht verfügbar.`
};

const en_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `We are unable to obtain the information.`
};

const es_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `No hemos podido obtener la información.`
};

const fr_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `Nous n'arrivons pas à obtenir l'information.`
};

const it_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `Non riusciamo a ottenere le informazioni.`
};

const nl_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `We kunnen de informatie niet krijgen.`
};

const pt_address__summary__error__detail = /** @type {(inputs: {}) => string} */ () => {
	return `Não conseguimos obter a informação.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.address__summary__error__detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("address__summary__error__detail", locale)
	if (locale === "de") return de_address__summary__error__detail(inputs)
	if (locale === "en") return en_address__summary__error__detail(inputs)
	if (locale === "es") return es_address__summary__error__detail(inputs)
	if (locale === "fr") return fr_address__summary__error__detail(inputs)
	if (locale === "it") return it_address__summary__error__detail(inputs)
	if (locale === "nl") return nl_address__summary__error__detail(inputs)
	return pt_address__summary__error__detail(inputs)
};